import React from 'react';
import { FaMapMarkerAlt, FaEdit, FaWrench } from 'react-icons/fa';
import './HowItWorks.css';

const HowItWorks = ({ onOrderNow }) => {
  const steps = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Passo 1 de 3",
      description: "Selecione o local da entrega e o modelo do veículo"
    },
    {
      icon: <FaEdit />,
      title: "Passo 2 de 3", 
      description: "Finalize o pedido e o pagamento será somente na entrega"
    },
    {
      icon: <FaWrench />,
      title: "Passo 3 de 3",
      description: "A Única vai até você com entrega e instalação grátis"
    }
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Precisando de bateria para o seu carro?
          </h2>
        </div>
        
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-icon">
                {step.icon}
              </div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="section-cta">
          <button className="btn-primary btn-large" onClick={onOrderNow}>
            PEÇA AGORA
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
